import Api from 'api/v2/Api';
import axios from 'axios';

class PasswordManagerApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/passwordmanager';
  }

  /**
   * @returns {Promise<{ data: { applicationId: string } }>}
   */
  getPasswordManager() {
    return this.initialize()
      .then(() => axios.get(this.baseUrl));
  }

  /**
   * @returns {Promise<{ data: { apiKey: string } }>}
   */
  activatePasswordManager() {
    return this.initialize()
      .then(() => axios.post(this.baseUrl, {}));
  }

  deactivatePasswordManager() {
    return this.initialize()
      .then(() => axios.delete(this.baseUrl));
  }

  fetchAccessLevels() {
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}/sharedfolders/accessLevels`));
  }

  /**
   * @returns {Promise<{
   * sharedFolders: number,
   * pendingInvites: number,
   * totalUsers: number,
   * devices: [
   *   {
   *     id: number,
   *     name: string,
   *     count: number
   *   }
   * ]
   * }>}
   */
  fetchStatistics() {
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}/overview`));
  }
}

export default new PasswordManagerApi();
